<div class="row justify-content-center">
    <div class="col-lg-2 col-md-2 col-6 text-center" *ngFor="let data of clients_logo">
        <img src="{{ data.image }}" style="min-width: 150px; min-height: 50px" class="avatar avatar-ex-sm" alt="" />
    </div>
</div>
